export default __webpack_public_path__ + "static/media/facebook_outlined.c0671a57.svg";